import { InferType, object, string, array } from 'yup';
import moment from 'moment';
import i18n from '@components/i18n';
import { yupFile, yupMultipleFiles } from '@utils/yup';
import { formValuesSchema as baseSchema } from '../HealthPolicyClaim/schema';

export const formValuesSchema = baseSchema.concat(
  object({
    accidentHappenedAt: string()
      .default(() => moment(new Date()).format('YYYY-MM-DDTHH:mm'))
      .required(i18n.t('validation:required')),
    accidentPhotos: yupMultipleFiles({ required: true }),
    passengersAndThirdPartiesPoliceReports: yupMultipleFiles({ required: true }),
    claimTypes: array(string().required(i18n.t('validation:required')))
      .default([])
      .min(1, i18n.t('validation:required')),
    invoice: yupFile().default(null).optional(),
  }))

export type FormValues = InferType<typeof formValuesSchema>;
